import { InfoRounded } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import useAPI from "../api/hooks/useAPI";
import useColors from "../api/hooks/useColors";

const InfoCalculationButton = ({ label, anchorEl, setAnchorEl }) => {
  const { trackEvent } = useAPI();
  const colors = useColors();
  return (
    <Button
      sx={{
        display: "flex",
        flexDirection: "row",
        px: 1,
        borderRadius: "10px",
        border: `1px solid ${colors.enabled_stroke}`,
        backgroundColor: anchorEl ? colors.grey_8percent : colors.common_white,
        "&:hover": {
          backgroundColor: colors.grey_8percent,
        },
        textTransform: "none",
        height: "36px",
      }}
      onClick={(e) => {
        trackEvent(`User clicked ${label} popover`);
        setAnchorEl((prev) => (prev ? null : e.currentTarget));
      }}
      startIcon={
        <InfoRounded
          sx={{
            fontSize: "18px !important",
            color: colors.grey_48percent,
          }}
        />
      }
    >
      <Typography
        variant="overline"
        sx={{
          color: colors.text_secondary,
          lineHeight: "1",
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};

export default InfoCalculationButton;
